import React from 'react'
import { render } from 'react-dom'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';

// Highcharts.setOptions({
//         colors: ['#444444', '#194f90', '#981211', '#d6a419', '#023a67', '#7a2d1b', '#be8637', '#ad967e']
// });

function Pie(props) {
    const options = {
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '{point.percentage:.1f} %'
                },
                showInLegend: true
            }
        },
        tooltip: {
            pointFormat: '<b>{point.percentage:.1f}%</b>'
        },
        chart: {
            type:"pie"
        },
        colors: ['#444444', '#194f90', '#981211', '#d6a419', '#023a67', '#7a2d1b', '#be8637', '#ad967e'],
        title: {
          text: props.title
        },
        legend: {
            symbolWidth: 12,
            symbolRadius: 0,
            squareSymbol: true
         },
        series: [{
            name: '',
            minPointSize: 10,
            innerSize: '50%',
            zMin: 0,
            data: props.data
        }]
      }
    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
             <p class="highcharts-description">
                <i>Pie charts are considering only positive values.</i>
            </p>
        </div>
    )
}

export default Pie
